export const getFileExtension = file => {
  let nameOfFile = file.name;
  let extentensionIndex = nameOfFile.lastIndexOf(".");
  let fileExtension = nameOfFile.substr(extentensionIndex + 1);

  return fileExtension;
};
